
import ReceiptText from "../../../assets/duotone/ReceiptText.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ReceiptTextIcon({ className, dataTestid = "ReceiptTextIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ReceiptText data-testid={dataTestid} className={classes} {...rest} />
  );
}
